<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['student_bursary'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-busary size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Bursary</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.name,
                            data.item.bursarytype,
                            data.item.bursaryvalue,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-busary"
        centered
        title="New Bursaries"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addFeesCategory">
          <div class="form-group mb-2">
            <label>Bursary Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Bursary Type</label>
            <select class="form-control" v-model="bursarytype"
              ><option>Full Bursary</option
              ><option>Half Bursary</option
              ><option>Custom</option
              ><option>Percentage</option></select
            >
          </div>
          <div class="form-group mb-2" v-if="bursarytype == 'Custom'">
            <label>Custom</label>
            <input v-model="bursaryvalue" type="number" class="form-control" />
          </div>
          <div class="form-group mb-2" v-else-if="bursarytype == 'Percentage'">
            <label>Percentage</label>
            <input v-model="bursaryvalue" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-busary')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-busary"
        centered
        title="Edit Bursaries"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editFeesCategory">
          <div class="form-group mb-2">
            <label>Bursary Name</label>
            <input v-model="name" type="text" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Bursary Type</label>
            <select class="form-control" v-model="bursarytype"
              ><option>Full Bursary</option
              ><option>Half Bursary</option
              ><option>Custom</option
              ><option>Percentage</option></select
            >
          </div>
          <div class="form-group mb-2" v-if="bursarytype == 'Custom'">
            <label>Custom</label>
            <input v-model="bursaryvalue" type="number" class="form-control" />
          </div>
          <div class="form-group mb-2" v-else-if="bursarytype == 'Percentage'">
            <label>Percentage</label>
            <input v-model="bursaryvalue" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-busary')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-busary"
        centered
        title="Delete Bursaries"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesCategory">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Bursaries : <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-busary')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { busarieMethods, busarieComputed } from "@/state/helpers";

export default {
  page: {
    title: "Bursaries",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Bursaries",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Bursaries", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "bursarytype", label: "Type", visible: true },
        { key: "bursaryvalue", label: "Value", visible: true },
        { key: "created_at", label: "Created At", visible: true },
        { key: "addedby", label: "Added By", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      name: "",
      bursarytype: "",
      bursaryvalue: "",
    };
  },
  computed: {
    ...busarieComputed,
    List() {
      return this.busaries.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.busaries.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.busaries.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchBusaries();
    this.TotalRows = this.busaries.length;
    this.isBusy = false;
  },
  methods: {
    ...busarieMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name, bursarytype, bursaryvalue) {
      this.id = id;
      this.name = name;
      this.bursarytype = bursarytype;
      this.bursaryvalue = bursaryvalue;
      this.$bvModal.show("edit-busary");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-busary");
    },
    async addFeesCategory() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("bursarytype", this.bursarytype);
      formData.append("bursaryvalue", this.bursaryvalue);
      let url = "/addbusary";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchBusaries();
          this.$bvModal.hide("new-busary");
          this.name = "";
          this.bursarytype = "";
          this.bursaryvalue = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editFeesCategory() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("bursarytype", this.bursarytype);
      formData.append("bursaryvalue", this.bursaryvalue);
      let url = "/updatebusary";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchBusaries();
          this.$bvModal.hide("edit-busary");
          this.name = "";
          this.bursarytype = "";
          this.bursaryvalue = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeFeesCategory() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removebusary";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchBusaries();
          this.$bvModal.hide("delete-busary");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
